import React, { useContext, useState, useEffect } from 'react';
import { Modal, Tag, Tooltip, Empty } from 'antd';
import { Container, PreviewTemplateDetails } from '../../Modals/styles';
import { dateConversion } from '../../../utils/javascript';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import { PreviewPopUpSm } from '../../Modals/styles';
import { PreviewContainer, TabsContainer, TabsContent } from '../styles';
import ShortMessageChannels from '../EditingArea/Channels';
import { AppStoreContext } from '../../../context/appStoreContext';
import { jsonToShortMessage } from '../../../utils/JsonConversion/jsonToShortMessage';
import { useTranslation } from 'react-i18next';
import { SHORT_MESSAGE_TEMAPLTES_PREVIEW } from './translationValues';
import { IS_WHATSAPP_ENABLED } from '../../../utils/helper';
/* This component shows the preview of all channels(draft version)
  Child Components: 
    * ShortMessageChannels
*/
const NAMESPACES = ['SHORT_MESSAGE_TEMAPLTES_PREVIEW'];
const ShortMessagePreview = props => {
  const { visible, onCancel, targetTemplate } = props;
  const { t } = useTranslation(NAMESPACES);
  const { globalVariables } = useContext(AppStoreContext);
  const [shortMessageContent, setShortMessageContent] = useState(undefined);
  const [currentTab, setCurrentTab] = useState(IS_WHATSAPP_ENABLED ? 1 : 2);
  const [isWhatsAppEmpty, setIsWhatsAppEmpty] = useState(!IS_WHATSAPP_ENABLED);
  const [isSMSEmpty, setIsSMSEmpty] = useState(false);
  const [isCallEmpty, setIsCallEmpty] = useState(false);

  useEffect(() => {
    updateTab();
    updateData();
    // eslint-disable-next-line
  }, []);

  const updateData = async () => {
    const msgContent = await jsonToShortMessage(targetTemplate, globalVariables);
    const shortMessageText = msgContent?.shortMessageText;
    setIsWhatsAppEmpty(!IS_WHATSAPP_ENABLED || shortMessageText?.whatsapp.length === 0);
    setIsSMSEmpty(shortMessageText?.sms.length === 0);
    setIsCallEmpty(shortMessageText?.call.length === 0);
    setShortMessageContent(msgContent);
  };

  const updateTab = () => {
    if (isWhatsAppEmpty) setCurrentTab(2);
    if (isWhatsAppEmpty && isSMSEmpty) setCurrentTab(3);
  };
  return (
    <Container>
      <Modal
        title={null}
        centered
        visible={visible}
        width="50vw"
        onCancel={onCancel}
        style={{ padding: '0px !important' }}
        footer={null}
      >
        <PreviewTemplateDetails>
          <h2>{targetTemplate.name}</h2>
          <p>
            {targetTemplate.updatedOn
              ? dateConversion(targetTemplate.updatedOn)
              : dateConversion(targetTemplate.createdOn)}
          </p>
          {targetTemplate.tags && (
            <div className="tags-div">
              {targetTemplate.tags.split(',').map(tag => {
                const isLongTag = tag.length > 20;
                const tagElement = (
                  <Tag className="edit-tag" key={tag} color="#df4c35">
                    <span>{isLongTag ? `${tag.slice(0, 20)}...` : tag}</span>
                  </Tag>
                );
                return isLongTag ? (
                  <Tooltip title={tag} key={tag}>
                    {tagElement}
                  </Tooltip>
                ) : (
                  tagElement
                );
              })}
            </div>
          )}
        </PreviewTemplateDetails>
        <PreviewPopUpSm>
          {isWhatsAppEmpty && isSMSEmpty && isCallEmpty ? (
            <PreviewContainer isSideBar={false} isEmpty={true}>
              <Empty
                image={Empty.PRESENTED_IMAGE_SIMPLE}
                description={t(
                  SHORT_MESSAGE_TEMAPLTES_PREVIEW.EMPTY_CHANNELS_INPUT_ERROR_MESSAGE.key,
                  SHORT_MESSAGE_TEMAPLTES_PREVIEW.EMPTY_CHANNELS_INPUT_ERROR_MESSAGE.value,
                )}
              />
            </PreviewContainer>
          ) : (
            <PreviewContainer isSideBar={false} previewPopup={true}>
              {[isWhatsAppEmpty, isSMSEmpty, isCallEmpty].filter(i => i === false).length > 1 ? (
                <TabsContainer
                  currentTab={currentTab}
                  popupPreview={true}
                  tabsWidth={!isWhatsAppEmpty && !isSMSEmpty && !isCallEmpty ? 3 : 2}
                >
                  {IS_WHATSAPP_ENABLED && !isWhatsAppEmpty && (
                    <div className="Tabs" onClick={() => setCurrentTab(1)}>
                      {currentTab === 1 && <div className="gradient-pill"></div>}
                      {t(
                        SHORT_MESSAGE_TEMAPLTES_PREVIEW.WHATSAPP_MESSAGE_CHANNEL_TAB_NAME.key,
                        SHORT_MESSAGE_TEMAPLTES_PREVIEW.WHATSAPP_MESSAGE_CHANNEL_TAB_NAME.value,
                      )}
                    </div>
                  )}
                  {!isSMSEmpty !== '' && (
                    <div className="Tabs" onClick={() => setCurrentTab(2)}>
                      {currentTab === 2 && <div className="gradient-pill"></div>}
                      {t(
                        SHORT_MESSAGE_TEMAPLTES_PREVIEW.SMS_CHANNEL_TAB_NAME.key,
                        SHORT_MESSAGE_TEMAPLTES_PREVIEW.SMS_CHANNEL_TAB_NAME.value,
                      )}
                    </div>
                  )}
                  {!isCallEmpty && (
                    <div className="Tabs" onClick={() => setCurrentTab(3)}>
                      {currentTab === 3 && <div className="gradient-pill"></div>}
                      {t(
                        SHORT_MESSAGE_TEMAPLTES_PREVIEW.VOICE_MESSAGE_CHANNEL_TAB_NAME.key,
                        SHORT_MESSAGE_TEMAPLTES_PREVIEW.VOICE_MESSAGE_CHANNEL_TAB_NAME.value,
                      )}
                    </div>
                  )}
                </TabsContainer>
              ) : (
                <TabsContainer />
              )}
              <TabsContent
                className="div-section"
                style={{ justifyContent: 'center' }}
                isSideBar={false}
                popupPreview={true}
              >
                <TransitionGroup>
                  <CSSTransition key={currentTab} timeout={500} classNames="slides">
                    <ShortMessageChannels
                      currentPriviewTab={currentTab - 1}
                      isPreview={true}
                      shortMsgPreviewContent={shortMessageContent}
                    />
                  </CSSTransition>
                </TransitionGroup>
              </TabsContent>
            </PreviewContainer>
          )}
        </PreviewPopUpSm>
      </Modal>
    </Container>
  );
};

export default ShortMessagePreview;
